const data=[
    {
        id:"5",
        titre:"Prise en main de A2W Academie",
        description:`Voici une courte formation sur comment utiliser la plateforme pour apprendre 
         et valider vos connaissances`,
        tech:"A2W Plateforme",
        delai:"15 min",
        cout:"Gratuit",
        bonus:"",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2FWhatsApp%20Image%202022-04-05%20at%2017.01.03(1).jpeg?alt=media&token=10a8c0d0-d83e-4baf-97b2-7b3e5c9eb462"
    },
    {
        id:"6",
        titre:"Les bases de la programmation avec Python",
        description:`ous avez beaucoup de tâches fastidieuses et répétitives au travail ? 
        Vous voulez être capable de faire des choses plus efficacement ? Python peut vous aider !<br /><br />
        Python est l’un des langages de programmation les plus utilisés. 
        Apprendre à coder avec Python est une compétence très recherchée dans beaucoup de métiers. 
        Et pas uniquement pour les développeurs logiciels à temps plein. Tout le monde peut apprendre !`,
        tech:"Python",
        delai:"8 heures",
        cout:"Gratuit",
        bonus:"",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2Fpath_518.avif?alt=media&token=c861f590-78e7-44ea-80c1-1fc4124c7ee0"
    },
    {
        id:"1",
        titre:"Création des applications web",
        description:`Vous souhaitez maîtriser la programmation web et devenir un as du langage informatique ? 
        Obtenez votre qualification d'intégrateur web pour travailler en freelance, 
        en agence ou en entreprise. <br /><br />
        Réalisez votre formation à distance, à votre rythme. 
        Vous serez accompagné par nos formateurs experts`,
        tech:"HTML, CSS, Javascript, Firebase, ReactJS",
        delai:"3 mois",
        cout:"50 000 FCFA",
        bonus:"2 livres offerts",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2Fappli_web.png?alt=media&token=d570c8e6-9599-4c9a-8633-939dae55e906"
    },
    {
        id:"2",
        titre:"Création des applications mobile",
        description:`Avec l’essor des nouvelles technologies et la multiplication des smartphones, 
        des techniciens du digital naissent.
        <br /><br />
         Le métier de développeur d’applications mobiles
         participe au boom numérique : désormais les entreprises ont besoin d’artisans du digital. 
         <br /><br />
         Le développeur a pour coeur de métier de créer des applications, d’adapter des sites web sur
          mobile ou bien d’en optimiser des existantes. Il va développer et concevoir.
        `,
        tech:"React Native",
        delai:"3 mois",
        cout:"30 000 FCFA",
        bonus:"",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2Fappli_mobile.png?alt=media&token=8d8e7d15-fd05-4465-a5c0-7a93f4791644"
    },
    {
        id:"3",
        titre:"Création des applictions desktop",
        description:`Le développement d’applications desktop t’intéresse et tu souhaites en 
        apprendre davantage ? Pour ta culture personnelle, par curiosité ou bien 
        tout simplement pour des raisons professionnelles ?<br /><br />
        En tant que développeur, tu souhaites créer une petite application mais tu ne veux pas 
        apprendre un langage lourd et souhaites réutiliser tes connaissances HTML/CSS/JS ?<br /><br />

        Tu as entendu parler d’un outil permettant de simplement créer une appli cross-plateforme 
        facilement nommée Electron ?<br/>
        Et bien bonne nouvelle, tu as trouvé LA formation qu’il te faut !`,
        tech:"Electron JS",
        delai:"3 mois",
        cout:"30 000 FCFA",
        bonus:"",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2Fappli_desktop.png?alt=media&token=1ed032ce-1d76-4469-99db-33fa2a80903e"
    },
    {
        id:"4",
        titre:"Cybersécurité (Hacking Ethique)",
        description:`Bienvenue dans ce cours vidéo sur le hacking éthique !<br /><br />

        À travers celui-ci, vous allez apprendre beaucoup de concepts fondamentaux en sécurité informatique.<br /><br />
        
        Le cours se veut à la fois pratique et interactif, vous aurez de quoi vous entraîner sur vos systèmes sans rien casser et vous pourrez poser vos questions à tout moment si vous en avez.
        <br /><br />
        Les cyberattaques les plus populaires seront traitées dans ce cours, de façon à vous enseigner les bases de la cybersécurité dans les grands domaines informatiques (web, réseau, système, etc). 
        Le tout dans le respect des lois et de l'éthique du hacking.`,
        tech:"Programmation, Systèm, Securité, Réseau, Cloud, Pentest",
        delai:"9 mois",
        cout:"150 000 FCFA",
        bonus:"",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%2Fethical_hacking.jpeg?alt=media&token=38fe87fd-bc72-4362-8606-ae9ca9387311"
    }
]

const books=[
    {
        id:"1",
        titre:"Construire une application web avec Javascript et Firebase | TOME 1",
        description:"",
        tech:"HTML, CSS, Javascript, Firebase",
        cout:"7000 FCFA",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%"
    },

    {
        id:"1",
        titre:"Construire une application web avec Javascript et Firebase | TOME 2",
        description:"",
        tech:"Node JS, Firebase MongoDB, MYSQL",
        cout:"7000 FCFA",
        photo:"https://firebasestorage.googleapis.com/v0/b/africa-web-warriors.appspot.com/o/images%"
    }
];

export {data,books};